module.exports = __webpack_public_path__ + "static/media/off.a5f6afa5.mp3";